import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import VenueCourtApi from './VenueCourtApi';

let settings;

export default settings = {
    key: 'venue/courts',
    zone: 'venue',
    path: '/venue/courts',
    title: "Venue Courts",
    endpoint: VenueCourtApi.endpoint,
    modelName: 'VenueCourt',
    idKey: 'id',
    primaryKey: 'title',
    actions: ['trash', 'clone'],
    indexCaps: ["viewVenueCourt"],
    viewCaps: ["viewVenueCourt"],
    createCaps: ["createVenueCourt"],
    updateCaps: ["updateVenueCourt"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path
            },
            {
                label: "Draft",
                path: settings.path + "/status/draft",
            },
            {
                label: "Preview",
                path: settings.path + "/status/preview",
            },
            {
                label: "Publish",
                path: settings.path + "/status/publish",
            },
            {
                label: "Archive",
                path: settings.path + "/status/archive",
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: VenueCourtApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['sport', 'category', 'operator', 'host'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "draft", label: "Draft" },
                    { value: "preview", label: "Preview" },
                    { value: "publish", label: "Publish" },
                    { value: "archive", label: "Archive" },
                ],
            },
            {
                label: "Host",
                key: "hostId",
                type: "relationship",
                model: "Hosts",
            },
            {
                label: "Operator",
                key: "operatorId",
                type: "relationship",
                model: "VenueOperator",
            },
            {
                label: "Sport",
                key: "sportId",
                type: "relationship",
                model: "Sport",
            },
            {
                label: "Category",
                key: "categoryId",
                type: "relationship",
                model: "VenueCategory",
            },
            {
                label: "Featured",
                key: "isFeatured",
                type: "choice",
                options: [
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" }
                ],
            }
        ];


        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Title",
                key: "this",
                format: "ModelLink",
                sort: 'title'
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase",
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink",
            },
            {
                label: "Operator",
                key: "operator",
                format: "ModelLink",
            },
            {
                label: "Sport",
                key: "sport",
                format: "ModelLink",
            },
            {
                label: "Category",
                key: "category",
                format: "ModelLink",
            },
            {
                label: "Featured",
                key: "isFeatured",
                format: "switch"
            },
            {
                label: "Priority",
                key: "priority",
                sort: true
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: VenueCourtApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: VenueCourtApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['sport', 'category', 'operator', 'host'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
        ]

    },
};